var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChessQueen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8947 5.78922C13.5501 5.46085 14 4.78297 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 4.78297 10.4499 5.46085 11.1053 5.78922L10 7.99986L7.48501 6.3232C7.32656 6.21756 7.12411 6.37219 7.18433 6.55285L8.76277 11.2882C8.83733 11.2633 8.91709 11.2499 9 11.2499H15C15.0829 11.2499 15.1627 11.2633 15.2372 11.2882L16.8157 6.55285C16.8759 6.37219 16.6734 6.21756 16.515 6.3232L14 7.99986L12.8947 5.78922Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.093 12.7441L15.875 19H17C17.5523 19 18 19.4477 18 20V21C18 21.5523 17.5523 22 17 22H7C6.44771 22 6 21.5523 6 21V20C6 19.4477 6.44772 19 7 19H8.12498L8.90697 12.7441C8.93745 12.7479 8.9685 12.7499 9 12.7499H15C15.0315 12.7499 15.0626 12.7479 15.093 12.7441Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessQueen);
export default __webpack_public_path__ + "static/media/chess-queen.4454f11064f561a52cebb85352d3e5af.svg";
export { ForwardRef as ReactComponent };